<template>
  <div v-if="isVisible">
    <div :class="$style.overlay"></div>
    <div :class="$style.paper">
      <button v-if="showCloseButton" :class="$style.closeButton" @click="closeModal" aria-label="닫기">
        ×
      </button>

      <img :class="$style.logo" alt="Linkook logo" src="@/assets/images/linkooklive_longlogo.png" />

      <h5>{{ title }}</h5>
      <div :class="$style.inputs">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaperModalContainer",
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close"],
  computed: {
    showCloseButton() {
      return !this.hideCloseButton;
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style module>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  z-index: 900;
}

.paper {
  position: fixed;
  width: 100%;
  max-width: 1024px;
  height: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  background-color: #fff;
  padding: 18px;
  border-radius: 0;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
  text-align: center;
  max-height: 100vh;
  overflow-y: auto;
  box-sizing: border-box;
}

.closeButton {
  position: fixed;
  top: 12px;
  right: 12px;
  background: #fff;
  font-size: 24px;
  font-weight: bold;
  color: #999;
  cursor: pointer;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  z-index: 1001;
}

.closeButton:hover {
  background-color: #f5f5f5;
  color: #666;
  transform: scale(1.1);
}

.closeButton:active {
  transform: scale(0.95);
  background-color: #e0e0e0;
}

.paper h5 {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  margin: 5px;
}

.inputs {
  width: 96%;
  margin: auto;
}

.logo {
  width: 65%;
  max-width: 300px;
}

/* Small (~ 480px) */
@media screen and (max-width: 480px) {
  .paper {
    padding: 14px;
    box-shadow: none;
  }

  .closeButton {
    top: 10px;
    right: 10px;
    font-size: 22px;
    width: 32px;
    height: 32px;
  }

  .logo {
    width: 55%;
    max-width: 200px;
  }

  .paper h5 {
    font-size: 14px;
    margin: 4px;
  }

  .inputs {
    width: 98%;
  }
}
</style>
